/* ============
 * Partner Transformer
 * ============
 *
 * The transformer for the partner.
 */

import Transformer from './transformer';

export default class PartnerTransformer extends Transformer {

  static fetch(partner) {
    return {
      id: partner.id,
      name: partner.name,
    };
  }

  static send(partner) {
    return {
      id: partner.id,
      name: partner.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/partner.js